var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"display":"block"},attrs:{"id":"myframe","name":"myframe","width":"100%","height":"100%","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }